export default "__VITE_ASSET__01943913__"